<div>
  <span *ngFor="let item of items; let i=index">{{item.name}}{{(i==items.length-1) ? '' : ', '}}</span>
</div>